import React, { useEffect } from 'react'
import { IAuthContext, AuthProviderProps } from './interface'
import { useAppDispatch } from '../../redux/store'
import { getMe } from '../../redux/reducers/auth'

const AuthContext = React.createContext<IAuthContext>({
  me: null,
  setMe: () => {},
})

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getMe())
  }, [dispatch])

  return <>{children}</>
}

export default AuthContext

export { AuthProvider }
